export default "__VITE_PUBLIC_ASSET__3004cbdd__"